// extracted by mini-css-extract-plugin
module.exports = {"antRow":"ListAdmins_antRow__3Kh73","addForm":"ListAdmins_addForm__2_MLg"};